import { render, staticRenderFns } from "./Ringer.vue?vue&type=template&id=2bd9b818"
import script from "./Ringer.vue?vue&type=script&lang=js"
export * from "./Ringer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports